// fileInKiB(3841) returns '3.8'
// fileInKiB(45678) returns '45.7'
// fileInKiB(1000) returns '1'

const fileInKiB = fileSize => {
  const decimalDigits = (fileSize % 1000) === 0 ? 0 : 1;
  return (fileSize / 1000).toFixed(decimalDigits);
};

export default fileInKiB;
